module.exports = __webpack_public_path__ + "img/hash.53b90aa7.svg";